import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
})
export class WarningModalComponent {
  @ViewChild('warningModal') public warningModal!: NgbModalRef;
  protected dModal: any;
  private loaded: boolean = false;

  private _show: boolean = false;
  @Input()
  set show(v: boolean) {
    if (this.loaded) {
      if (v)
        this.dModal = this._modalServ.open(this.warningModal, {
          backdrop: 'static',
          centered: true,
        });
      else this.dModal.dismiss();
    } else this.loaded = true;
  }
  get show() {
    return this._show;
  }

  @Input() headerTitle: string = '';
  @Input() heading: string = '';
  @Input() text: string = '';
  @Input() yesText: string = 'Yes';
  @Input() noText: string = 'No';
  @Input() singleAction: boolean = false;
  @Input() yesLoading: boolean = false;
  @Input() noLoading: boolean = false;

  @Output() onYes: EventEmitter<void> = new EventEmitter();
  @Output() onNo: EventEmitter<void> = new EventEmitter();

  constructor(private _modalServ: NgbModal) { }
}
